import i18next from "i18next";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
function readText(file) {
  return new Promise((resolve, reject) => {
    if (typeof file === "undefined") {
      throw new DeveloperError(i18next.t("core.readText.fileRequired"));
    }
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = function (event) {
      var _event$target;
      const allText = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.result;
      resolve(allText !== null && allText !== void 0 ? allText : undefined);
    };
    reader.onerror = function (e) {
      reject(e);
    };
  });
}
export default readText;